import { render, staticRenderFns } from "./iconChevronHaut.vue?vue&type=template&id=4b268464"
import script from "./iconChevronHaut.vue?vue&type=script&lang=js"
export * from "./iconChevronHaut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports